import React, { useEffect, useState } from 'react';
import styled from 'styled-components'


const getWidth = (progressId) => document.getElementById(progressId).getBoundingClientRect().width

const ProgressBar = ({ value, color, progressId }) => {
  let [width, setWidth] = useState(1);

  useEffect(() => {
    setWidth(getWidth(progressId))
    const resizeListener = () => {
      setWidth(getWidth(progressId))
    };

    window.addEventListener('resize', resizeListener);
    return () => {
      window.removeEventListener('resize', resizeListener);
    }
  }, [progressId, value, color])

  return(    
  <Wrapper id={progressId}>
    <Bar color={color} width={(width*value)/100} />
  </Wrapper>
)}


export default ProgressBar


const Wrapper = styled.div(props => ({
  width:"100%",
  height:2,
  background:"rgba(196, 196, 196, 0.5)",
  position:"relative",
}));

const Bar = styled.div(props => ({
  background: props.color,
  position:"absolute",
  left:0,
  height:4,
  top:-1,
  transition:"0.4s",
  width:props.width,
  borderRadius:2,
}));
